<template>
  <div class="pay-now">
    <el-dialog
      :visible.sync="dialogConfirmVisible"
      :width="dialogWidth"
      :before-close="ConfirmReceiptClose"
      :title="$t('orderList.PayNow')"
      @close="handleClose">
      <template v-if="!isBatch">
          <div class="shippingAddress f-b content_item p-r">
            <div class="left">
              <div style="font-weight: bold;margin-bottom: 10px;height: 30px;" class="f-b-c text_tip">
                  <div class="f--c"><i class="el-icon-location-information" style="margin-right:4px"></i>{{ $t('Order.List.Components.PayDialog.ShippingAddress') }}</div>
                  <div class="select-another-address pointer" style="text-align: right;" @click="editAddress(orderInfo.address)" v-if="product.platformCode !== 'KA'">{{ $t('Order.List.Components.PayDialog.Edit') }}</div>
              </div>
              <div class="left-address f-b" style="flex-direction: column;">
                <div style="color:#8B93A3;padding: 20px">
                  {{addressCurrent.recipient}} {{ addressCurrent.phone}}
                  <p>{{addressCurrent.street1}}</p>
                  <p v-if="addressCurrent.street2">{{addressCurrent.street2}}</p>
                  {{addressCurrent.city}} {{addressCurrent.province}} {{ addressCurrent.country}} {{ addressCurrent.zip }}
                </div>
                <div style="width:100%">
                  <img src="../../../../assets/img/Group1858.png" style="width:100%;height:4px">
                </div>
              </div>
            </div>
            <div class="right">
              <div style="font-weight: bold;margin-bottom: 10px;height: 30px;" class="f-b-c text_tip">
                <div>{{ $t('orderDetail.Note') }}</div>
                <el-button type="text" @click="showEdit"><strong>{{ $t('orderDetail.Edit') }}</strong></el-button>
              </div>
              <!-- 没有备注时备注提示内容颜色置灰 -->
              <div class="right-note" :style="{ color: orderInfo.orders && orderInfo.orders.remark ? '#606266' : '#ccc' }">
                <div>{{  orderInfo.orders && orderInfo.orders.remark ? orderInfo.orders.remark : $t('orderDetail.NoteTip') }}</div>
              </div>

            </div>
          </div>
          <div class="f" style="margin: 0 20px 0 20px;border: 1px dashed #747A87;" v-loading="loading">
            <div class="left">
              <div class="orderAmount">
                <h2 style="margin-bottom: 10px" class="title">{{ $t('Order.List.Components.PayDialog.OrderAmount') }}</h2>
                <div class="f-b subtotal_item">
                    <p style="color: #747A87">{{ $t('Order.List.Components.PayDialog.Subtotal') }}</p>
                    <p>US ${{pays.skusAmount}}</p>
                </div>
                <div class="f-b subtotal_item">
                    <p style="color: #747A87">{{ $t('Order.List.Components.PayDialog.ShippingFee') }}</p>
                    <p>US ${{pays.freightAmount | priceHandle}}</p>
                </div>
                <div class="f-b subtotal_item">
                    <p style="color: #747A87">{{ $t('Order.List.Components.PayDialog.Discount') }}</p>
                    <p :class="{haveCut: pays.discountAmount}">-US ${{pays.discountAmount | priceHandle}}</p>
                </div>

                <!-- 优惠码金额 -->
                <div class="f-b subtotal_item">
                  <p style="color: #747A87">{{ $t('Order.List.Components.PayDialog.PromoCode') }}</p>
                  <p v-if="orderInfo.orders && orderInfo.orders.orderType === 5">-US $0.00</p>
                  <el-popover
                    v-else
                    placement="top"
                    trigger="hover">
                    <div>
                      <div>Promo Code</div>
                      <div v-if="!pays.couponCode">you didn't use a promo code</div>
                      <div v-else>
                        <span v-if="orderBillingPreviewInfo.couponCodeInfo">
                          {{ `${orderBillingPreviewInfo.couponCodeInfo.discountCondition===1?('Order '+orderBillingPreviewInfo.couponCodeInfo.satisfyNum+', '):orderBillingPreviewInfo.couponCodeInfo.discountCondition===2?('Spend $'+orderBillingPreviewInfo.couponCodeInfo.satisfyAmount+', '):''}` }}
                          Get
                          {{`${orderBillingPreviewInfo.couponCodeInfo.discountRule===1?(orderBillingPreviewInfo.couponCodeInfo.discountPercent+'% off'):('$'+orderBillingPreviewInfo.couponCodeInfo.discountFixed+' off')}`}}
                        </span>
                      </div>
                    </div>
                    <p slot="reference" :class="{ haveCut: pays.couponAmount}" style="font-size: 16px" @click="showEditCoupon(1)">
                      -US ${{ pays.couponAmount | priceHandle }}
                      <i class="el-icon-arrow-right"></i>
                    </p>
                  </el-popover>
                </div>

                <!-- 优惠券金额 -->
                <div class="f-b subtotal_item">
                  <p style="color: #747A87">Coupon</p>
                  <p v-if="orderInfo.orders && orderInfo.orders.orderType === 5">-US $0.00</p>
                  <el-popover
                    v-else
                    placement="top"
                    trigger="hover">
                    <div>
                      <div>Coupon</div>
                      <div v-if="!pays.couponTicketId">you didn't use a promo coupon</div>
                      <div v-else>
                        <span v-if="orderBillingPreviewInfo.couponTicketInfo && orderBillingPreviewInfo.couponTicketInfo.receiveUsageRules  && orderBillingPreviewInfo.couponTicketInfo.receiveUsageRules.offerTypeInfo">
                          {{`${orderBillingPreviewInfo.couponTicketInfo.receiveUsageRules.offerTypeInfo.fixedType===1?('$'+orderBillingPreviewInfo.couponTicketInfo.receiveUsageRules.offerTypeInfo.reduction+' off'):(orderBillingPreviewInfo.couponTicketInfo.receiveUsageRules.offerTypeInfo.reduction+'% off')}`}}
                        </span>
                      </div>
                    </div>
                    <p slot="reference" :class="{ haveCut: pays.couponTicketAmount}" style="font-size: 16px" @click="showEditCoupon(2)">
                      -US ${{ pays.couponTicketAmount | priceHandle }}
                      <i class="el-icon-arrow-right"></i>
                    </p>
                  </el-popover>
                </div>

                <el-divider></el-divider>
                <div class="f-b subtotal_all f--c">
                    <p>{{ $t('Order.List.Components.PayDialog.Total') }}：</p>
                    <p>US ${{pays.totalAmount | priceHandle}}</p>
                </div>
            </div>
            </div>
            <div class="right">
              <div class="paymentMethods">
                <div class="PleaseSelectThePaymentMethod">
                  {{ $t('orderList.PleaseSelectThePaymentMethod')}}
                </div>
                <div class="radioSelect">
                  <el-radio :label="2" v-model="radioValue">{{ $t('orderList.Paypal')}}</el-radio>
                  <img class="pay-icon" src="@/assets/img/icon/paypal.png" alt=""/>
                </div>
                <!-- <div v-if="$store.state.common.userGroup === 100" class="radioSelect">
                  <el-radio :label="4" v-model="radioValue">{{ $t('orderList.CreditCard')}}</el-radio>
                  <img class="pay-icon" src="@/assets/img/icon/creditcard1.png" alt=""/>
                </div>
                <div v-else class="radioSelect">
                  <el-radio :label="9" v-model="radioValue">{{ $t('orderList.CreditCard')}}</el-radio>
                  <img class="pay-icon" src="@/assets/img/icon/creditcard1.png" alt=""/>
                </div> -->
                <!-- 2025.06.09 信用卡逻辑调整 全部用空中云汇的（陈琼瑜） -->
                <div class="radioSelect">
                  <el-radio :label="4" v-model="radioValue">{{ $t('orderList.CreditCard')}}</el-radio>
                  <img class="pay-icon" src="@/assets/img/icon/creditcard1.png" alt=""/>
                </div>
                <div class="radioSelect">
                  <el-radio :label="0" v-model="radioValue" :disabled="parseFloat(balance) < pays.totalAmount">{{ `${$t('orderList.Balance')}  ${balance}` }}</el-radio>
                </div>
                <div class="radioSelect">
                  <el-radio :label="3" v-model="radioValue">{{ $t('Order.List.Components.PayDialog.Others') }}</el-radio>
                  <img class="pay-icon" src="@/assets/img/icon/zfb_wx.png" alt=""/>
                </div>
                <!-- 2025.11.07 40seas支付 去掉 -->
                <!-- <div v-if="info40Seas" class="radioSelect">
                  <el-radio :label="8" v-model="radioValue" :disabled="info40Seas.status !== 'approved' || +pays.totalAmount > info40Seas.availableCredit || +pays.totalAmount < 2000">40Seas
                    <img style="position: relative;height:15px;margin:0 4px;top:2px" src="https://img.kakaclo.com/web-img/home/40seas/logo.png?x-oss-process=image/resize,w_20,h_20,m_fill/format,webp" alt="">
                    <span v-if="info40Seas.status === 'approved'">({{ `${$t('Index.PaymentPage.AvailableBalance')}:${info40Seas.availableCredit}` }})
                      <el-tooltip v-if="+pays.totalAmount < 2000" effect="dark" :content="$t('Index.PaymentPage.Tips40seas1')" placement="top-start">
                        <i class="iconfont icon-help pointer" style="color:#99c41c;"></i>
                      </el-tooltip>
                    </span>
                    <span v-else-if="['pending', 'manual review'].includes(info40Seas.status) " style="color:#C0C4CC">({{ $t('Index.PaymentPage.UnderReview') }})</span>
                    <span v-else-if="info40Seas.status === 'declined'" style="color:#C0C4CC">({{ $t('Index.PaymentPage.AuditRejected') }})</span>
                    <span v-else style="color:#518EFF;text-decoration:underline;padding-left:6px;cursor: pointer;" @click="payment40SeasBuyerCreditline(true)"> {{ $t('Index.PaymentPage.ApplyNow') }}</span>
                  </el-radio>
                </div> -->
                <div class="payNow">
                  <el-button type="primary" :loading="loading" @click="submit" style="width: 300px">{{ radioValue == 8 ? $t('Index.PaymentPage.PayLater') : $t('Order.List.Components.PayDialog.PayNow') }}</el-button>
                </div>
              </div>
            </div>
          </div>

          <!-- 是否添加配件 -->
          <div class="productParts bg-white content_item">
            <h3 style="margin-bottom: 20px;font-size:18px">{{ $t('Order.List.Components.PayDialog.CustomizedService') }}</h3>
            <el-checkbox-group v-model="attachmentSelectedList" @change="changeAttachment()">
              <template v-for="item in defaultAttachmentsList">
                <el-checkbox :key="item" :label="item" :disabled="!attachmentsList.some(e=>e.type === item)"></el-checkbox>
              </template>
              <!-- 目前只有一个吊牌，待后续新增后再去除这两个 -->
              <!-- <el-checkbox label="Tags" :disabled="!attachmentsList.some(e=>e.type === 'Tags')">{{ $t('Order.List.Components.PayDialog.Tags') }}</el-checkbox>
              <template v-if="attachmentsList.length < 2">
                <el-checkbox :label="$t('Order.List.Components.PayDialog.Package')" :disabled="true"></el-checkbox>
                <el-checkbox :label="$t('Order.List.Components.PayDialog.Bags')" :disabled="true"></el-checkbox>
              </template> -->
            </el-checkbox-group>
          </div>
          <div v-for="(item, i) in orderInfo.logistics" :key="item.countryCode+item.warehouseCode" class="deliveryMethod" v-loading="deliveryLoading">
            <div class="f-b" style="margin-bottom: 10px">
              <h2 style="font-size:20px">{{ $t('Order.List.Components.PayDialog.DeliveryMethod') }}</h2>
              <h3 style="font-size:16px">{{ $t('Order.List.Components.PayDialog.Warehouses') }}: {{ item.countryName }}</h3>
            </div>
            <template v-if="product.platformCode === 'KA'">
              <div class="channel_group">
                <div class="channel_item channel_item_active pointer" style="color: #99C41C">
                  <!-- {{orders.isExpress === 1? 'Fast Shipping': 'Standard Shipping'}} ({{item.deliveryTime}} {{item.estimatedFreight}}) -->
                  {{orders.isExpress === 0? 'Standard' : orders.isExpress === 2 ? 'Expedited ' : 'Express' }} ({{item.deliveryTime}}, ${{item.estimatedFreight}})
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="item.channelList.length">
                <div class="channel_group">
                  <div class="channel_item" v-for="t in item.channelList" :key="item.countryCode+t.channelCode" :class="{channel_item_active: warehouseChannelList[i].channelCode === t.channelCode}">
                    <el-radio v-model="warehouseChannelList[i].channelCode" :label="t.channelCode" @input="e => channelChange (e, i)">
                      <!-- {{`${t.channelType}(${t.deliveryTime}, $${t.estimatedFreight})`}} -->
                      {{`${t.agingGrade}(${t.deliveryTime}, $${t.estimatedFreight})`}}
                    </el-radio>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="f">
                  <div class="image" style="margin-right:14px">
                    <img src="../../../../assets/img/Group2151.png" style="height:40px;width:40px">
                  </div>
                  <div style="font-size:16px;line-height:24px">
                    <p style="color:#E3444E">{{ $t('Order.List.Components.PayDialog.LogisticsError') }}.</p>
                    <p>{{ $t('Order.List.Components.PayDialog.Tips1') }}</p>
                  </div>
                </div>
              </template>
            </template>
          </div>
          <!-- <div class="deliveryMethod" v-loading="deliveryLoading">
            <div class="f-b" style="margin-bottom: 10px">
              <h2 style="font-size:20px">{{ $t('Order.List.Components.PayDialog.DeliveryMethod') }}</h2>
              <h3 style="font-size:16px">{{ $t('Order.List.Components.PayDialog.Warehouses') }}: {{ `China` }}</h3>
            </div>
            <template v-if="product.platformCode === 'KA'">
              <div class="channel_group">
                <div class="channel_item channel_item_active pointer" style="color: #99C41C">
                  {{orders.isExpress === 1? 'Fast Shipping': 'Standard Shipping'}} ({{orders.deliveryTime}} {{orders.estimatedFreight}})
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="channelList.length">
                <div class="channel_group">
                  <div class="channel_item" v-for="item in channelList" :key="item.channelCode" :class="{channel_item_active: channelActive === item.channelCode}">
                    <el-radio v-model="channelActive" :label="item.channelCode" @change="channelChange">
                      {{`${item.channelType}(${item.deliveryTime}, $${item.estimatedFreight})`}}
                    </el-radio>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="f">
                  <div class="image" style="margin-right:14px">
                    <img src="../../../../assets/img/Group2151.png" style="height:40px;width:40px">
                  </div>
                  <div style="font-size:16px;line-height:24px">
                    <p style="color:#E3444E">{{ $t('Order.List.Components.PayDialog.LogisticsError') }}.</p>
                    <p>{{ $t('Order.List.Components.PayDialog.Tips1') }}</p>
                  </div>
                </div>
              </template>
            </template>
          </div> -->
      </template>
      <template v-else>
        <div style="padding-left: 60px;padding-bottom:24px">
          <div style="font-size: 24px;font-weight:bold;line-height:36px">US ${{totalAmountForBatch}}</div>
          <div style="color: #8B93A3;font-size: 18px;line-height:28px">{{ $t('Order.List.Components.PayDialog.PaymentAmount') }}</div>
        </div>
        <div class="paymentMethods" style="padding-left: 60px">
          <div class="PleaseSelectThePaymentMethod">
            {{ $t('orderList.PleaseSelectThePaymentMethod')}}
          </div>
          <div class="radioSelect">
            <el-radio :label="2" v-model="radioValue">{{ $t('orderList.Paypal')}}</el-radio>
            <img class="pay-icon" src="@/assets/img/icon/paypal.png"/>
          </div>
          <!-- <div v-if="$store.state.common.userGroup === 100" class="radioSelect">
            <el-radio :label="4" v-model="radioValue">{{ $t('orderList.CreditCard')}}</el-radio>
            <img class="pay-icon" src="@/assets/img/icon/creditcard1.png"/>
          </div>
          <div v-else class="radioSelect">
            <el-radio :label="9" v-model="radioValue">{{ $t('orderList.CreditCard')}}</el-radio>
            <img class="pay-icon" src="@/assets/img/icon/creditcard1.png"/>
          </div> -->
          <!-- 2025.06.09 信用卡逻辑调整 全部用空中云汇的（陈琼瑜） -->
          <div class="radioSelect">
            <el-radio :label="4" v-model="radioValue">{{ $t('orderList.CreditCard')}}</el-radio>
            <img class="pay-icon" src="@/assets/img/icon/creditcard1.png"/>
          </div>
          <div class="radioSelect">
            <el-radio :label="0" v-model="radioValue" :disabled="parseFloat(balance) < product.totalAmount">{{ `${$t('orderList.Balance')}  ${balance}` }}</el-radio>
          </div>
          <div class="radioSelect">
            <el-radio :label="3" v-model="radioValue">{{ $t('Order.List.Components.PayDialog.Others') }}</el-radio>
            <img class="pay-icon" src="@/assets/img/icon/zfb_wx.png"/>
          </div>
        </div>
        <!-- 是否添加配件 -->
        <div class="bg-white content_item" style="padding-left: 60px;margin-top: 30px;margin-bottom:70px">
          <h3 style="margin-bottom: 20px;font-size:18px">{{ $t('Order.List.Components.PayDialog.CustomizedService') }}</h3>
          <el-checkbox-group v-model="attachmentSelectedList">
            <template v-for="item in defaultAttachmentsList">
              <el-checkbox :key="item" :label="item" :disabled="!attachmentsList.some(e=>e.type === item)"></el-checkbox>
            </template>
            <!-- <el-checkbox label="Tags" :disabled="!attachmentsList.some(e=>e.type === 'Tags')">{{ $t('Order.List.Components.PayDialog.Tags') }}</el-checkbox> -->
            <!-- 目前只有一个吊牌，待后续新增后再去除这两个 -->
            <!-- <template v-if="attachmentsList.length < 2">
              <el-checkbox :label="$t('Order.List.Components.PayDialog.Package')" :disabled="true"></el-checkbox>
              <el-checkbox :label="$t('Order.List.Components.PayDialog.Bags')" :disabled="true"></el-checkbox>
            </template> -->
          </el-checkbox-group>
        </div>
        <div class="payNow" style="text-align:center">
          <el-button type="primary" @click="submit" style="width: 300px">{{ $t('Order.List.Components.PayDialog.PayNow') }}</el-button>
        </div>
      </template>
    </el-dialog>
    <Paypal ref="paypal" @success="paySuccess" @fail="payFail" />
    <QianHai ref="qianhai" @success="paySuccess" @fail="payFail" />
    <Airwallex ref="airwallex" :payCallbackUrl="payCallbackUrl" @success="paySuccess" @fail="payFail" />
    <Payoneer ref="payoneer" :payCallbackUrl="payoneerCallbackUrl" @payoneerError="handlePayoneerError" />
    <!-- MT 移动端选择弹窗 -->
    <SelectPaymentMethod
      :visible.sync="MTPayNowVisible"
      :totalAmount="product.totalAmount"
      v-model="MTPaymentMethod"
      @payNow="MtpayNow"
      :attachmentsList="attachmentsList"
      :radioValue="radioValue"
      :attachmentSelectedList="attachmentSelectedList"
      @paymentMethodChange="e => radioValue = e"
      @changeAttachment="changeAttachment"
      ref="SelectPaymentMethod"></SelectPaymentMethod>
    <AddressDialog ref="addressdialog" :addForm="addressForm" @submitForm="getAddressList" :isOrderAddress="true" @orderAddressChange="orderChangeAddress" @resetIsPayoneerError="handleResetIsPayoneerError"></AddressDialog>
    <addresswrongPayDialog ref="addresswrongPayDialog" @continueToPay="continueToPayBatch"></addresswrongPayDialog>
    <el-dialog
      :title="$t('Order.List.Components.PayDialog.SoldOutProduct')"
      :visible.sync="soldOutShow"
      width="600px"
      class="sold-out-dialog">
      <template v-if="isBatch">
        <template  v-for="(item, i) in product.orderItemsMore">
          <div v-if="item.some(t=> [0, 2, 3, 4].includes(t.skuStatus))" :key="'more'+i" style="margin-bottom:26px">
            <div style="margin-bottom:8px">{{ product.kkOrderIds[i] }}</div>
            <template v-for="t in item">
              <div v-if="[0, 2, 3, 4].includes(t.skuStatus)" :key="t.skuCode" class="sold-out f--c">
                <div class="sku">{{ t.skuCode }}</div>
                <div class="status">{{ t.skuStatus === 0 ? $t('publishListings.notAvailable') : $t('publishListings.soldOut') }}</div>
              </div>
            </template>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="sold-out f--c">
          <div class="sku">SKU</div>
          <div class="status">State</div>
        </div>
        <template v-for="item in product.orderItems">
          <div v-if="[0, 2, 3, 4].includes(item.skuStatus)" :key="item.skuCode" class="sold-out f--c">
            <div class="sku">{{ item.skuCode }}</div>
            <div class="status">{{ item.skuStatus === 0 ? $t('publishListings.notAvailable') : $t('publishListings.soldOut') }}</div>
          </div>
        </template>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="soldOutShow = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="showDialog">{{ $t('Order.List.Components.PayDialog.ContinueToPay') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('Order.List.Components.PayDialog.OrderConfirmation')"
      :visible.sync="soldOutShow"
      :close-on-click-modal="false"
      width="600px"
      class="sold-out-dialog">
      <p class="full-width" style="line-height:40px;color:#FABF70;background-color:#FDF6EC;margin-bottom:10px;padding-left:20px;">{{ $t('Order.List.Components.PayDialog.OOSTip') }}</p>
      <p v-if="isPC && !isBatch && product.orderItems.find(t => [0, 2, 3, 4].includes(+t.skuStatus))" style="margin-left:20px;margin-top:20px;">{{ $t('Order.List.Components.PayDialog.OOSItems') }}</p>
      <!-- 商品列表 -->
      <template v-for="product in product.orderItems">
        <div class="productItem f-b" v-if="[0, 2, 3, 4].includes(product.skuStatus)" :key="product.skuCode" style="margin-left:35px;margin-bottom:5px;">
          <div class="f">
            <div style="margin-right: 10px">
              <el-popover placement="right" width="280" trigger="hover">
                <el-image fit="cover" :src="product.imageUrl"></el-image>
                <div style="position: relative; width: 70px; height: 70px; border-radius: 6px" slot="reference">
                  <el-image style="width: 70px; height: 70px; border-radius: 6px" :src="product.imageUrl" slot="reference"></el-image>
                  <div v-if="[0,4].includes(product.skuStatus)" class="f-c-c" style="width: 70px; height: 70px; position: absolute; left: 0; top: 0; background: rgba(0, 0, 0, 0.37); border-radius: 6px; color: #f2f2f2; font-size: 12px">Out of Stock</div>
                </div>
              </el-popover>
            </div>
            <div class="skuInfo">
              <el-tooltip effect="dark" :content="product.productName" placement="top">
                <el-button type="text" class="ellipsis" style="max-width:450px;padding:0;line-height:20px;" @click="jumpDetailSeo(product.kkProductId)">{{ product.productName }}</el-button>
              </el-tooltip>
              <template v-if="product.options_render && product.options_render.length > 40">
                <el-tooltip effect="dark" :content="product.options_render" placement="top">
                  <div class="ellipsis" style="width: 260px; margin-bottom: 4px">{{ product.options_render }}</div>
                </el-tooltip>
              </template>
              <p v-else style="margin-bottom: 4px">{{ product.options_render }} <span style="font-size: 14px; margin-left: 20px">X {{ product.productNum }}</span></p>
              <div style="margin-right: 8px">SKU：{{ product.skuCode }}</div>
            </div>
          </div>
        </div>
      </template>
      <p v-if="isPC && !isBatch && product.orderItems.find(t => +t.skuStatus === 1)" style="margin-left:20px;margin-top:20px;">{{ $t('Order.List.Components.PayDialog.AvailableItems') }}</p>
      <!-- 商品列表 -->
      <template v-for="product in product.orderItems">
        <div class="productItem f-b" v-if="product.skuStatus === 1" :key="product.skuCode" style="margin-left:35px;margin-bottom:5px;">
          <div class="f">
            <div style="margin-right: 10px">
              <el-popover placement="right" width="280" trigger="hover">
                <el-image fit="cover" :src="product.imageUrl"></el-image>
                <div style="position: relative; width: 70px; height: 70px; border-radius: 6px" slot="reference">
                  <el-image style="width: 70px; height: 70px; border-radius: 6px" :src="product.imageUrl" slot="reference"></el-image>
                </div>
              </el-popover>
            </div>
            <div class="skuInfo">
              <el-tooltip effect="dark" :content="product.productName" placement="top">
                <el-button type="text" class="ellipsis" style="max-width:450px;padding:0;line-height:20px;" @click="jumpDetailSeo(product.kkProductId)">{{ product.productName }}</el-button>
              </el-tooltip>
              <template v-if="product.options_render && product.options_render.length > 40">
                <el-tooltip effect="dark" :content="product.options_render" placement="top">
                  <div class="ellipsis" style="width: 260px; margin-bottom: 4px">{{ product.options_render }}</div>
                </el-tooltip>
              </template>
              <p v-else style="margin-bottom: 4px">{{ product.options_render }} <span style="font-size: 14px; margin-left: 20px">X {{ product.productNum }}</span></p>
              <div style="margin-right: 8px">SKU：{{ product.skuCode }}</div>
            </div>
          </div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="soldOutShow = false">{{ $t('Cancel') }}</el-button>
        <el-button type="primary" :loading="loading" @click="oosSplit()">{{ $t('Order.List.Components.PayDialog.ContinueWithoutOOSItems') }}</el-button>
      </span>
    </el-dialog>
    <!-- 编辑备注内容提交后刷新页面订单数据 -->
    <order-note-edit ref="orderNoteEdit" @EditNoteSuccess="getOrderInfo"></order-note-edit>

    <!-- 编辑优化券优化码 -->
    <edit-coupon-dialog
      ref="editCouponDialog"
      :kkOrderId="product.kkOrderIds.length && product.kkOrderIds[0]"
      @getOrderInfo="getOrderInfo">
    </edit-coupon-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { guid } from '@/util/uuid'
import API from '@/api'
import Paypal from '@/components/Paypal.vue'
import QianHai from '@/components/QianHai.vue'
import Airwallex from '@/components/Airwallex.vue'
import Payoneer from '@/components/Payoneer.vue'
import bus from '@/util/bus'
import SelectPaymentMethod from '@/components/mobile/SelectPaymentMethod.vue'
import AddressDialog from '@/views/commodity/components/AddressDialog'
import addresswrongPayDialog from './addressWrongPayDialog.vue'
import { gtagReport } from '@/util/gtag'
import OrderNoteEdit from '@/views/order/details/components/OrderNoteEdit.vue'
import EditCouponDialog from './editCouponDialog.vue'
export default {
  components: {
    Paypal,
    QianHai,
    Airwallex,
    Payoneer,
    SelectPaymentMethod,
    AddressDialog,
    addresswrongPayDialog,
    OrderNoteEdit,
    EditCouponDialog
  },
  filters: {
    priceHandle(value) {
      if (value) return value.toFixed(2)
      return '0.00'
    }
  },
  data() {
    return {

      isPayoneerErrorAddBillingAddress: false,
      radioValue: 0,
      dialogConfirmVisible: false,
      balance: 0,
      product: {
        kkOrderIds: [],
        orderItems: [],
        platformCode: 'KA',
        totalAmount: 0
      },
      transactionOrderId: '', // 交易单号
      loading: false,
      MTPayNowVisible: false,
      MTTotalAmount: 0,
      MTPaymentMethod: 2,
      orderInfo: {
        orders: {}
      },
      channelList: [{ channelType: '', deliveryTime: '', estimatedFreight: '' }],
      channelActive: undefined,
      warehouseChannelList: [], // 订单选中的物流渠道
      selectAddressIndex: 0,
      deliveryLoading: false,
      addressForm: {},
      isBatch: false,
      totalAmountForBatch: 0,
      dialogWidth: '1094px',
      attachmentSelectedList: [],
      attachmentsList: [],
      defaultAttachmentsList: [
        'Tags',
        'Bags',
        'Cards'
      ],

      paymentId: '', // 付款成功id 交易单id
      soldOutShow: false,

      info40Seas: {}, // 40seas-获取用户信用额度

      orderBillingPreviewInfo: {},
      coupons: [],
      SplitOrderIds: undefined // 拆单数据
    }
  },
  watch: {
    MTPayNowVisible(val, old) {
      if (!val) {
        this.MTTotalAmount = 0
        this.MTPaymentMethod = 0
      }
    },
    selectAddressIndex: {
      immediate: false,
      async handler() {
        if (this.product.platformCode !== 'KA') this.orderChangeAddress(this.addressList[this.selectAddressIndex])
      }
    }
  },
  created() {
    bus.$on('showPayDialog', this.show)
    this.$once('hook:beforeDestroy', () => {
      bus.$off('showPayDialog', this.show)
    })
    this.$store.dispatch('common/getBalance')
    this.payment40SeasBuyerCreditline()
  },
  computed: {
    address() {
      let address = {}
      if (this.$store.state.common.addressList.length) {
        address = this.$store.state.common.addressList[0]
      } else {
        this.$store.dispatch('common/getAddressList')
      }
      return address
    },
    payCallbackUrl() {
      return `${location.origin}/payment-status?state=success&orderId=${this.product.kkOrderIds && this.product.kkOrderIds[0]}&paymentMethod=${this.radioValue}&paymentAmount=${this.product.totalAmount}`
    },
    payoneerCallbackUrl() {
      return `${location.origin}/payment-status?orderId=${this.product.kkOrderIds && this.product.kkOrderIds[0]}`
    },
    addressList() {
      return this.$store.state.common.addressList
    },
    pays() {
      if (this.orderInfo.pays) return this.orderInfo.pays
      return {}
    },
    orders() {
      if (this.orderInfo.orders) return this.orderInfo.orders
      return { isExpress: 1, deliveryTime: '', estimatedFreight: '' }
    },
    addressCurrent() {
      if (this.orderInfo.address) return this.orderInfo.address
      return {
        city: '',
        country: '',
        email: '',
        phone: '',
        province: '',
        recipient: '',
        street1: '',
        street2: '',
        zip: ''
      }
    }
  },
  methods: {
    // 40seas-获取用户信用额度
    payment40SeasBuyerCreditline(isApply) {
      API.payment40SeasBuyerCreditline().then(res => {
        if (res.code === 10000) {
          this.info40Seas = res.data || {}
          if (isApply && this.info40Seas.status !== 'approved ') {
            this.applyNow()
          }
        }
      })
    },
    // 申请40seas
    applyNow() {
      API.payment40SeasBuyer().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        window._40Seas.open(res.data.token, {
          onCancel: () => {
            window._40Seas.close()
          }
        })
      })
    },
    // 40seas-唤起40seas支付控件
    payment40SeasCheckout() {
      let self = this
      this.loading = true
      API.payment40SeasCheckout(this.paymentId).then(res => {
        window._40Seas.open(res.data.token, {
          onConfirm: (payload) => {
            // console.log('User entity was conifrmed', payload)
            window._40Seas.close()
            self.paySuccess()
          },
          onCancel: (payload) => {
            // console.log('User closed the modal at page ' + payload.page)
            window._40Seas.close()
          }
        })
      }).finally(() => {
        this.loading = false
      })
    },

    async submit() {
      // 2026.3.17 停用支付功能
      return this.$message.error('Effective today, KakaClo will stop its dropshipping service.New orders can no longer be paid.')

      //   // 支付方式为信用卡支付，且无收货地址时，提示用户去添加收货地址
      //   // if (+this.radioValue === 1 && this.$store.state.common.addressList.length === 0) {
      //   //   return this.$message.info('Please set the receiving address first or pay by other means')
      //   // }
      //   /*
      //   2  Paypal
      //   1  Credit Card  信用卡
      //   0  Balance  余额支付
      // */
      //   if (this.isBatch) {
      //   // 校验地址信息是否完整
      //     const res = await API.whetherToPay({ kkOrderId: this.product.kkOrderIds })
      //     if (res.data.isPass === 1) {
      //       await this.putProductAttachmentsBatch()
      //       this.createTransactionOrder(this.totalAmountForBatch, this.radioValue, this.product.kkOrderIds)
      //     } else {
      //       this.$refs.addresswrongPayDialog.show(res.data)
      //     }
      //     return
      //   }
      //   if (!this.checkAddressInfo() && this.orderInfo.orders.orderType !== 5) {
      //     this.editAddress(this.orderInfo.address)
      //     this.$nextTick(() => {
      //       this.$message.error({
      //         message: 'Missing Required Information',
      //         customClass: 'message_Zindex'
      //       })
      //     })
      //     return
      //   }
      //   if (this.product.platformCode !== 'KA' && this.channelList.length && this.channelList.every(e => e.code !== 10000 || !e.data.length)) {
      //     return this.$message.error(this.$t('Order.List.Components.PayDialog.LogisticsError') + ', ' + this.$t('Order.List.Components.PayDialog.Tips1'))
      //   }
      //   if (this.product.orderType !== 5) {
      //     await this.putProductAttachments()
      //   }
      //   this.createTransactionOrder(this.orderInfo.pays.totalAmount, this.radioValue, this.product.kkOrderIds)
    },
    /**
   * 创建交易单
   * amount 订单总金额
   * paymentMethod  支付方式
   * kkOrderIds {Array} 订单id
   */
    createTransactionOrder(amount, paymentMethod, kkOrderIds) {
      let product = {
        ...this.product,
        paymentMethod: this.radioValue
      }
      localStorage.setItem('product_order', JSON.stringify(product))
      this.loading = true
      API.createTransactionOrder({
        amount,
        paymentMethod: +this.radioValue === 4 ? 3 : this.radioValue,
        currencyCode: 'USD',
        paymentType: this.product.platformCode === 'KA' ? 0 : 1,
        ext: this.product.ext,
        kkOrderIds
      }).then(result => {
        if (result.code !== 10000) return this.$message.error(result.message)
        this.transactionOrderId = result.data
        const addr = this.address
        this.paymentId = result.data
        switch (+paymentMethod) {
          case 0:
            this.balancePayment(result.data)
            break
          case 1:
            this.$refs.qianhai.show({
              order_number: result.data, // 订单号
              order_amount: amount, // 交易金额
              billing_lastName: this.$store.state.common.userName, // 持卡人名
              billing_firstName: this.$store.state.common.userName, // 持卡人姓
              billing_email: this.$store.state.common.email, // 持卡人邮箱
              billing_country: addr.countryCode || 'N/A', // 持卡人国家
              billing_state: addr.province || 'N/A', // 持卡人州/省
              billing_city: addr.city || 'N/A', // 持卡人城市
              billing_address: addr.streetAddressLine1 || 'N/A', // 持卡人地址
              billing_zip: addr.zipCode || 'N/A', // 持卡人邮编
              productName: this.product.productName, // 产品名称
              productNum: this.product.productNum, // 数量
              productSku: this.product.skuCode
            })
            break
          case 2:
            this.$refs.paypal.show(result.data)
            break
          case 3:
            this.$refs.airwallex.show(result.data, ['wechatpay', 'alipaycn'])
            break
          case 4:
            this.$refs.airwallex.show(result.data, ['card'])
            break
          case 9:
            this.$refs.payoneer.show(result.data)
            break
          case 8:
            this.payment40SeasCheckout()
            break
        }
      }).catch(err => {
        let message = err.message || err.data.message
        this.$message.error(message)
      }).finally(() => {
        this.loading = false
      })
    },
    /**
   * 余额付款
   */
    balancePayment(paymentId) {
      API.balancePayment(paymentId).then(result => {
        this.$store.dispatch('common/getBalance').then(() => this.paySuccess())
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 支付成功回调
    paySuccess(data) {
      // 谷歌电子商务 购买埋点
      gtagReport(this.paymentId)
      this.loading = false
      let product = JSON.parse(localStorage.getItem('product_order'))
      let totalAmount = this.product.totalAmount
      // 如果是单个订单支付orderInfo内是最新的
      if (this.orderInfo.pays && this.orderInfo.pays.totalAmount) totalAmount = this.orderInfo.pays.totalAmount
      let query = {
        state: 'success',
        orderId: product.kkOrderIds[0],
        paymentAmount: totalAmount,
        paymentMethod: product.paymentMethod
      }
      this.$router.push({
        path: '/payment-status',
        query
      })
      localStorage.removeItem('product_order')
    },
    /**
   * 支付失败
   */
    payFail(error) {
      localStorage.removeItem('product_order')
      this.$message.error(error.message || this.$t('orderDetail.payFail'))
    },
    show(product, isBatch) {
      this.isBatch = isBatch
      this.product = JSON.parse(JSON.stringify(product))
      // 普通用户要判断是否缺货，然后进行拆单，但是如果是独立站的话，则不需要，直接跳转支付页面
      if (product.storeGroup === -1) {
        if ((isBatch && product.orderItemsMore.some(item => item.some(t => [0, 2, 3, 4].includes(t.skuStatus)))) || (product.status === 'waiting_payment' && product.orderItems.some(t => [0, 2, 3, 4].includes(t.skuStatus))) && product.orderType !== 5) {
          this.soldOutShow = true
          return
        }
      }
      this.showDialog()
    },
    showDialog() {
      this.soldOutShow = false
      let product = this.product
      let isBatch = this.isBatch
      this.$store.dispatch('common/getBalance').then(balance => {
        this.balance = balance
        if (this.balance < this.product.totalAmount) this.radioValue = 2
        this.dialogConfirmVisible = true
      })
      if (this.isPC) {
        if (this.isBatch) {
          this.dialogWidth = '700px'
        } else {
          this.dialogWidth = '1094px'
        }
      } else {
        this.dialogWidth = '100%'
      }
      // 获取配件、判断配件初始状态
      // const { orderItems, orderItemsMore } = product
      this.getProductAttachments()
      // if (isBatch) {
      //   if (orderItemsMore[0][0].attachmentSkuVos) {
      //     this.attachmentSelectedList = orderItemsMore[0][0].attachmentSkuVos.map(e => e.type)
      //   }
      // } else {
      //   if (orderItems[0].attachmentSkuVos) this.attachmentSelectedList = orderItems[0].attachmentSkuVos.map(e => e.type)
      // }
      // if (isBatch) {
      //   API.getOrderBatchSum({ kkOrderIds: this.product.kkOrderIds }).then(res => {
      //     this.totalAmountForBatch = res.data
      //   })
      //   return
      // }
      // this.clickAutomaticSplitPack()
      // this.getOrderInfo().then(() => {
      //   if (this.product.platformCode !== 'KA') {
      //     this.getChannelList().then(() => {
      //       this.submitChannel(this.channelActive).then(() => {
      //         this.getOrderInfo()
      //       })
      //     })
      //   }
      // })
    },
    async clickAutomaticSplitPack() {
      if (this.product.platformCode !== 'KA') {
        await API.clickAutomaticSplitPack(this.product.kkOrderIds[0])
      }

      this.getOrderInfo().then(() => {
        if (this.product.platformCode !== 'KA') {
          this.getChannelList().then(() => {
            // this.submitChannel(this.channelActive).then(() => {
            //   this.getOrderInfo()
            // })
          })
        }
      })
    },

    showEditCoupon(type) {
      // if (this.orders.platformCode !== 'KA') return
      this.$refs.editCouponDialog.show(type, this.orderInfo, this.orderBillingPreviewInfo, this.coupons)
    },

    // 获取正在使用，可用优化券
    getOrderBillingPreviewInfo() {
      const param = {
        // 订单商品信息
        products: this.orderInfo.orderItems.map(t => ({
          kkProductId: t.kkProductId,
          skuCode: t.skuCode,
          skuOriginalPriceAmount: t.purchasePrices,
          skuQuantity: t.productNum
        })),
        couponCode: this.orderInfo.pays.couponCode,
        selectCouponTicketId: this.orderInfo.pays.couponTicketId,
        shippingSubtotal: this.orderInfo.pays.freightAmount, // 总运费
        ifApplication: false, // 当只有一张优惠券时是否自动应用：是否自动应用：true.应用 false.不应用
        platformCode: this.orderInfo.orders.platformCode
      }
      this.orderBillingPreviewInfo = {}
      this.coupons = []
      API.getOrderBillingPreviewInfo(param).then(({ code, message, data }) => {
        if (code !== 10000) {
          // this.$message.error(message)
          return
        }
        this.orderBillingPreviewInfo = data
        this.coupons = data.orderBillingFilterResults.couponTicketInfos ? data.orderBillingFilterResults.couponTicketInfos.map(t => ({ ...t, key: `${guid(5)}_${t.id}` })) : []
      })
    },

    // 关闭数据清空
    ConfirmReceiptClose() {
      this.dialogConfirmVisible = false
      this.radioValue = 2
      this.balance = undefined
      this.transactionOrderId = undefined
      Object.keys(this.product).forEach(key => {
        let type = Object.prototype.toString.call(this.product[key]).slice(8, -1)
        if (type === 'Array') {
          this.product[key] = []
        } else {
          this.product[key] = undefined
        }
      })
      this.orderInfo = {}
    },
    async MtpayNow({ paymentMethod, attachmentSelectedList }) {
      this.radioValue = paymentMethod
      this.attachmentSelectedList = attachmentSelectedList
      if (this.isBatch) {
        // 校验地址信息是否完整
        const res = await API.whetherToPay({ kkOrderId: this.product.kkOrderIds })
        if (res.data.isPass === 1) {
          await this.putProductAttachmentsBatch()
          this.createTransactionOrder(this.totalAmountForBatch, this.radioValue, this.product.kkOrderIds)
        } else {
          this.$refs.addresswrongPayDialog.show(res.data)
        }
        return
      }
      if (!this.checkAddressInfo()) {
        this.editAddress(this.orderInfo.address)
        this.$nextTick(() => {
          this.$message.error({
            message: 'Missing Required Information',
            customClass: 'message_Zindex'
          })
        })
        return
      }
      await this.putProductAttachments()
      this.createTransactionOrder(this.orderInfo.pays.totalAmount, paymentMethod, this.product.kkOrderIds)
    },
    MTShow({ product, isBatch }) {
      this.product = JSON.parse(JSON.stringify(product))
      this.isBatch = isBatch
      this.$store.dispatch('common/getBalance').then(balance => {
        this.balance = balance
        this.MTPayNowVisible = true
        this.clickAutomaticSplitPack()
      })
      // 获取配件、判断配件初始状态   suruchi.taneja@gmail.com指定客户才有
      // const { orderItems, orderItemsMore } = product
      // if (isBatch) {
      //   if (orderItemsMore[0][0].attachmentSkuVos) {
      //     this.attachmentSelectedList = orderItemsMore[0][0].attachmentSkuVos.map(e => e.type)
      //   }
      // } else {
      //   if (orderItems[0].attachmentSkuVos) this.attachmentSelectedList = orderItems[0].attachmentSkuVos.map(e => e.type)
      // }
      // this.$nextTick(() => {
      //   this.$refs.SelectPaymentMethod.setAttachmentSelectedList(this.attachmentSelectedList)
      // })
      this.getProductAttachments()
    },
    // 获取订单信息
    getOrderInfo() {
      return new Promise((resolve, reject) => {
        this.loading = true
        API.orderGetDetailToPay(this.product.kkOrderIds[0]).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          res.data.logistics && res.data.logistics.forEach((item, i) => {
            this.$set(item, 'channelList', [])
            if (this.channelList.length) {
              this.channelList.forEach(e => {
                if (e.code === 10000 && e.data && e.data.length && e.warehouseCode === item.warehouseCode) {
                  this.$set(item, 'channelList', e.data)
                }
              })
            }
          })
          this.orderInfo = res.data
          const { address } = this.orderInfo
          let selectAddressIndex = this.addressList.findIndex(e => {
            let checkWay = [address.country === e.countryCode, address.city === e.city, +address.phone === +e.phoneNumber, address.street1 === e.streetAddressLine1]
            return checkWay.every(e => e)
          })
          this.selectAddressIndex = selectAddressIndex > 0 ? selectAddressIndex : 0
          this.channelActive = this.orderInfo.orders.channelCode
          this.warehouseChannelList = this.orderInfo.logistics.map(item => ({ isExpress: item.isExpress, warehouseCode: item.warehouseCode, channelCode: item.channelCode }))
          this.radioValue = this.orderInfo.pays.paymentMethod
          this.$store.dispatch('common/getBalance').then(balance => {
            this.balance = balance
            if (this.balance < this.orderInfo.pays.totalAmount) {
              this.radioValue = 2
            }
          })
          if (!this.isBatch) {
            this.getOrderBillingPreviewInfo()
          }
          resolve()
        }).finally(() => {
          this.loading = false
        })
      })
    },
    getChannelList() {
      return new Promise((resolve, reject) => {
        const params = {
          warehouses: [
            // {
            //   termini: this.orderInfo.address.country,
            //   warehouseCode: this.orderInfo.warehouse.warehouseCode,
            //   channelGrouping: this.orderInfo.warehouse.channelGrouping,
            //   warehouseId: this.orderInfo.warehouse.warehouseId,
            //   products: this.orderInfo.orderItems.map(e => {
            //     return {
            //       skuCode: e.skuCode,
            //       quantity: e.productNum,
            //       kkProductId: e.kkProductId
            //     }
            //   })
            // }
          ],
          currency: 'USD'
        }
        let address = this.orderInfo.address
        this.orderInfo.logistics && this.orderInfo.logistics.forEach(item => {
          params.warehouses.push({
            termini: this.orderInfo.address.country,
            warehouseCode: item.warehouseCode,
            products: this.orderInfo.orderItems.filter(p => p.warehouseCode === item.warehouseCode).map(e => {
              return {
                skuCode: e.skuCode,
                quantity: e.productNum,
                kkProductId: e.kkProductId
              }
            }),
            province: address.province || undefined,
            city: address.city || undefined,
            zipCode: address.zip || undefined,
            street1: address.street1 || undefined,
            street2: address.street2 || undefined,
            platformCode: this.orderInfo.orders && this.orderInfo.orders.platformCode
          })
        })
        this.deliveryLoading = true
        API.getLogisticsChannel(params).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.channelList = res.data
          res.data.forEach(item => {
            let channelList = item.data
            if (item.code === 10000 && channelList.length) {
              channelList.forEach((e, i) => {
                if (i === 0) {
                  this.$set(e, 'channelType', 'Fast Shipping')
                } else {
                  this.$set(e, 'channelType', 'Standard Shipping')
                }
              })
              this.orderInfo.logistics.forEach((e, i) => {
                if (e.warehouseCode === item.warehouseCode) {
                  this.$set(e, 'channelList', channelList)
                  if (channelList.some(t => t.agingGrade.toLowerCase() === this.orderInfo.orders.channelType)) {
                    let warehouseChannelObj = channelList.find(t => t.agingGrade.toLowerCase() === this.orderInfo.orders.channelType)
                    this.warehouseChannelList[i] = {
                      isExpress: warehouseChannelObj.agingGrade.toLowerCase() === 'standard' ? 0 : warehouseChannelObj.agingGrade.toLowerCase() === 'expedited' ? 2 : 1,
                      warehouseCode: e.warehouseCode,
                      channelCode: warehouseChannelObj.channelCode
                    }
                  } else if (channelList.findIndex(c => c.channelCode === e.channelCode) === -1) {
                    // this.warehouseChannelList[i] = {
                    //   isExpress: channelList[channelList.length > 1 ? 1 : 0].agingGrade === 'Express' ? 1 : 0,
                    //   warehouseCode: e.warehouseCode,
                    //   channelCode: channelList[channelList.length > 1 ? 1 : 0].channelCode
                    // }

                    // (2023/8/11: express > standard > expedited, 按这个循序取便宜的)
                    let warehouseChannelList = null
                    if (channelList.findIndex(t => t.agingGrade.toLowerCase() === 'express') > -1) {
                      warehouseChannelList = channelList[channelList.findIndex(t => t.agingGrade.toLowerCase() === 'express')]
                    } else if (channelList.findIndex(t => t.agingGrade.toLowerCase() === 'standard') > -1) {
                      warehouseChannelList = channelList[channelList.findIndex(t => t.agingGrade.toLowerCase() === 'standard')]
                    } else if (channelList.findIndex(t => t.agingGrade.toLowerCase() === 'expedited') > -1) {
                      warehouseChannelList = channelList[channelList.findIndex(t => t.agingGrade.toLowerCase() === 'expedited')]
                    } else {
                      warehouseChannelList = channelList[0]
                    }
                    this.warehouseChannelList[i] = {
                      isExpress: warehouseChannelList.agingGrade.toLowerCase() === 'standard' ? 0 : warehouseChannelList.agingGrade.toLowerCase() === 'expedited' ? 2 : 1,
                      warehouseCode: e.warehouseCode,
                      channelCode: warehouseChannelList.channelCode
                    }
                  }
                }
              })
            }
          })
          // if (this.channelList.findIndex(e => e.channelCode === this.orderInfo.orders.channelCode) !== -1) {
          //   this.channelActive = this.orderInfo.orders.channelCode
          // } else {
          //   if (this.channelList.length && this.channelList.length === 1) this.channelActive = this.channelList[0].channelCode
          //   if (this.channelList.length && this.channelList.length > 1) this.channelActive = this.channelList[1].channelCode
          // }
          resolve()
        }).finally(() => {
          this.deliveryLoading = false
        })
      })
    },
    getAddressList(address) {
      this.$refs.addressdialog._data.dialogVisible = false
      this.$refs.addressdialog._data.loading = false
      this.$store.dispatch('common/getAddressList')
      this.orderChangeAddress(this.addressForm)
    },
    orderChangeAddress(addressForm) {
      if (this.isPayoneerErrorAddBillingAddress) {
        this.payoneerErrorAddBillingAddress(addressForm)
        return
      }
      return new Promise((resolve, reject) => {
        const { countryCode: country, city, phoneNumber: phone, fullName: recipient, streetAddressLine1: street1, streetAddressLine2: street2, province, zipCode: zip } = addressForm
        const params = {
          data: {
            orderAddresses: {
              country,
              city,
              phone,
              recipient,
              street1,
              street2,
              province,
              zip
            },
            paymentMethod: 0
          },
          kkOrderId: this.product.kkOrderIds[0]
        }
        API.orderChangeAddress(params).then(res => {
          if (res.code !== 10000) {
            return this.$message.error(res.message)
          }
          this.addressForm = {}
          this.getOrderInfo().then(() => {
            this.getChannelList().then(() => {
              this.submitChannel(this.channelActive).then(() => {
                this.getOrderInfo()
              })
            })
          })
          resolve()
        }).catch(err => {
          this.$message.error(err.data.data)
          this.channelList = []
          reject()
        })
      })
    },
    // 当获取不到payoneer 报错时添加帐单地址
    payoneerErrorAddBillingAddress(addressForm) {
      addressForm.type = 1
      API.editAddress(addressForm).then(res => {
        this.dialogVisible = false
        this.$message.success(this.$t('promptText.msg23'))
        this.resetForm()
        this.$emit('submitForm')
        this.loading = false
      }).catch(result => {
        this.$message.error(result.data.message)
      }).finally(() => {
        this.loading = false
        this.isPayoneerErrorAddBillingAddress = false
      })
    },
    editAddress(address) {
      const { city, country: countryCode, email, phone: phoneNumber, province, recipient, street1: streetAddressLine1, street2: streetAddressLine2, zip: zipCode } = address
      let params = {
        type: 0,
        city,
        countryCode,
        email,
        phoneNumber,
        province,
        recipient,
        streetAddressLine1,
        streetAddressLine2,
        zipCode,
        fullName: this.product.customer
      }
      this.$set(this, 'addressForm', params)
      this.$refs.addressdialog.show(true)
    },
    channelChange(channelCode, i) {
      let channelList = this.orderInfo.logistics[i].channelList
      let agingGrade = channelList.filter(t => t.channelCode === channelCode)[0].agingGrade.toLowerCase()
      this.$set(this.warehouseChannelList[i], 'isExpress', agingGrade === 'standard' ? 0 : agingGrade === 'expedited' ? 2 : 1)
      this.submitChannel(channelCode).then(() => {
        this.getOrderInfo()
      })
    },
    submitChannel(channelCode) {
      return new Promise((resolve, reject) => {
        const params = {
          kkOrderId: this.product.kkOrderIds[0],
          data: {
            // channelCode
            warehouseChannelList: this.warehouseChannelList.map(item => ({ ...item }))
          }
        }
        API.orderChangeChannel(params).then((res) => {
          if (res.code !== 10000) {
            this.$message.error(res.message)
          }
          resolve()
        })
      })
    },
    submitBatch() {},
    checkAddressInfo() {
      const { phone, country, city, street1, zip } = this.orderInfo.address
      return [phone, country, city, street1, zip].every(e => e)
    },
    // 批量付款校验过后过滤地址信息缺失订单支付
    continueToPayBatch({ orderIds, totalAmount }) {
      if (totalAmount <= 0) {
        return this.$message.error('The total amount of the normal order is 0, please reconfirm')
      }
      this.product.totalAmount = totalAmount
      this.product.kkOrderIds = orderIds.map(e => e.kkOrderId)
      this.createTransactionOrder(this.product.totalAmount, this.radioValue, this.product.kkOrderIds)
    },
    // 用户配件列表
    getProductAttachments() {
      // 定制订单不加载配件
      if (this.product.orderType === 5) {
        this.attachmentsList = []
        this.clickAutomaticSplitPack()
        return
      }
      API.getNewProductAttachments().then(res => {
        this.attachmentsList = res.data

        const { orderItems, orderItemsMore } = this.product
        if (this.isBatch) {
          this.attachmentSelectedList = this.attachmentsList.map(e => e.type)
        } else {
          // this.attachmentSelectedList = orderItems[0].attachmentSkuVos && orderItems[0].attachmentSkuVos.length ? orderItems[0].attachmentSkuVos.map(e => e.type) : []
          this.attachmentSelectedList = this.attachmentsList.filter(e => {
            if (orderItems[0].attachmentSkuVos && orderItems[0].attachmentSkuVos.length) {
              return orderItems[0].attachmentSkuVos.some(t => e.type === t.type)
            }
          }).map(k => k.type)
        }
        if (this.isPC) {
          if (this.isBatch) {
            API.getOrderBatchSum({ kkOrderIds: this.product.kkOrderIds }).then(res => {
              this.totalAmountForBatch = res.data
            })
            return
          }
          this.clickAutomaticSplitPack()
        } else {
          this.$nextTick(() => {
            this.$refs.SelectPaymentMethod.setAttachmentSelectedList(this.attachmentSelectedList)
          })
        }
      })
    },
    // 配件切换更新
    changeAttachment(arr) {
      if (arr) {
        this.attachmentSelectedList = arr
      }
      this.putProductAttachments()
    },
    // 单个付款配件匹配
    putProductAttachments() {
      return new Promise((resolve, reject) => {
        // // 判断配件勾选状态与最初状态是否有更改，区分出新增的与删除的
        // let initialAttachments = []
        // if (this.product.orderItems && this.product.orderItems[0].attachmentSkuVos) {
        //   initialAttachments = this.product.orderItems[0].attachmentSkuVos.map(e => {
        //     return {
        //       kkItemId: e.kkItemId,
        //       kkOrderId: e.kkOrderId,
        //       skuCode: e.skuCode,
        //       type: e.type,
        //       id: e.id
        //     }
        //   })
        // }
        // // 新增的
        // let attachmentItemsAdd = this.attachmentSelectedList.map(e => {
        //   return this.attachmentsList.find(ee => ee.type === e)
        // }).map(e => e.skuCode).filter(skuCode => !initialAttachments.some(ee => ee.skuCode === skuCode))
        // // 删除的  sku维度，每个sku都要检索
        // let attachmentItemsDelete = initialAttachments.filter(e => this.attachmentSelectedList.every(type => type !== e.type)).map(e => e.type)
        // if (!attachmentItemsAdd.length && !attachmentItemsDelete.length) {
        //   resolve()
        //   return
        // }
        // const deleteArr = []
        // this.product.orderItems.forEach(e => {
        //   if (!e.attachmentSkuVos) return
        //   e.attachmentSkuVos.forEach(ee => {
        //     if (attachmentItemsDelete.includes(ee.type)) deleteArr.push({ id: ee.id })
        //   })
        // })
        // const params = {
        //   addOrderAttachments: [],
        //   deleteOrderAttachments: []
        // }
        // if (attachmentItemsAdd.length) {
        //   const attachmentItems = this.orderInfo.orderItems.map(e => {
        //     return {
        //       kkItemId: e.kkItemId,
        //       skuCodes: attachmentItemsAdd
        //     }
        //   }).filter(e => e.skuCodes.length)
        //   params.addOrderAttachments = [
        //     { kkOrderId: this.product.kkOrderIds[0], attachmentItems }
        //   ]
        // }
        // if (deleteArr.length) {
        //   params.deleteOrderAttachments = [{
        //     kkOrderId: this.product.kkOrderIds[0],
        //     attachmentItems: deleteArr
        //   }]
        // }
        // 2024.5.7 配件逻辑修改（张庆辉）
        // if (!this.attachmentsList.length) {
        //   resolve()
        //   return
        // }
        const params = {
          kkOrderIds: this.product.kkOrderIds,
          list: []
        }
        this.attachmentsList.forEach(item => {
          if (this.attachmentSelectedList.includes(item.type)) {
            if (item.type === 'Cards') {
              params.list.push({
                kkOrderId: this.product.kkOrderIds[0],
                // kkItemId: this.product.orderItems[0].kkItemId,
                skuCode: item.skuCode,
                name: item.name,
                imageUrl: item.imageUrl,
                type: item.type
              })
            } else {
              this.product.orderItems.forEach(t => {
                if (t.type !== 'Cards') {
                  params.list.push({
                    kkOrderId: this.product.kkOrderIds[0],
                    kkItemId: t.kkItemId,
                    skuCode: item.skuCode,
                    name: item.name,
                    imageUrl: item.imageUrl,
                    type: item.type
                  })
                }
              })
            }
          }
        })
        API.putProductAttachments(params).then(res => {
          resolve()
        })
      })
    },
    // 批量付款配件匹配
    putProductAttachmentsBatch() {
      return new Promise((resolve, reject) => {
        // const simpleProductCheck = (orderItem, kkOrderId) => {
        //   let initialAttachments = []
        //   if (orderItem[0].attachmentSkuVos) {
        //     initialAttachments = orderItem[0].attachmentSkuVos.map(e => {
        //       return {
        //         kkItemId: e.kkItemId,
        //         kkOrderId: e.kkOrderId,
        //         skuCode: e.skuCode,
        //         type: e.type,
        //         id: e.id
        //       }
        //     })
        //   }
        //   // 新增的
        //   let attachmentItemsAdd = this.attachmentSelectedList.map(e => {
        //     return this.attachmentsList.find(ee => ee.type === e)
        //   }).map(e => e.skuCode).filter(skuCode => !initialAttachments.some(ee => ee.skuCode === skuCode))
        //   // 删除的
        //   let attachmentItemsDelete = initialAttachments.filter(e => this.attachmentSelectedList.every(type => type !== e.type)).map(e => e.type)
        //   const deleteArr = []
        //   orderItem.forEach(e => {
        //     if (!e.attachmentSkuVos) return
        //     e.attachmentSkuVos.forEach(ee => {
        //       if (attachmentItemsDelete.includes(ee.type)) deleteArr.push({ id: ee.id })
        //     })
        //   })
        //   if (!attachmentItemsAdd.length && !attachmentItemsDelete.length) {
        //     return false
        //   }
        //   return {
        //     addOrderAttachments: [
        //       {
        //         kkOrderId: kkOrderId,
        //         attachmentItems: orderItem.map(e => {
        //           return {
        //             kkItemId: e.kkItemId,
        //             skuCodes: attachmentItemsAdd
        //           }
        //         }).filter(e => e.skuCodes.length)
        //       }
        //     ],
        //     deleteOrderAttachments: [
        //       {
        //         kkOrderId: kkOrderId,
        //         attachmentItems: deleteArr
        //       }
        //     ]
        //   }
        // }
        // const params = {
        //   addOrderAttachments: [],
        //   deleteOrderAttachments: []
        // }
        // for (let i = 0; i < this.product.kkOrderIds.length; i++) {
        //   let simpleParams = simpleProductCheck(this.product.orderItemsMore[i], this.product.kkOrderIds[i])
        //   if (simpleParams) {
        //     params.addOrderAttachments = [...params.addOrderAttachments, ...simpleParams.addOrderAttachments.filter(e => e.attachmentItems.length)]
        //     params.deleteOrderAttachments = [...params.deleteOrderAttachments, ...simpleParams.deleteOrderAttachments.filter(e => e.attachmentItems.length)]
        //   }
        // }
        // if (!params.addOrderAttachments.length && !params.deleteOrderAttachments.length) {
        //   resolve()
        //   return
        // }
        if (!this.attachmentsList.length) {
          resolve()
          return
        }
        const params = {
          kkOrderIds: this.product.kkOrderIds,
          list: []
        }
        const product = this.product
        product.orderItemsMore.forEach((item, i) => {
          this.attachmentsList.forEach(attachment => {
            if (this.attachmentSelectedList.includes(attachment.type)) {
              if (attachment.type === 'Cards') {
                params.list.push({
                  kkOrderId: product.kkOrderIds[i],
                  // kkItemId: product.orderItemsMore[i][0].kkItemId,
                  skuCode: attachment.skuCode,
                  name: attachment.name,
                  imageUrl: attachment.imageUrl,
                  type: attachment.type
                })
              } else {
                item.forEach(t => {
                  if (t.type !== 'Cards') {
                    params.list.push({
                      kkOrderId: product.kkOrderIds[i],
                      kkItemId: t.kkItemId,
                      skuCode: attachment.skuCode,
                      name: attachment.name,
                      imageUrl: attachment.imageUrl,
                      type: attachment.type
                    })
                  }
                })
              }
            }
          })
        })
        API.putProductAttachments(params).then(res => {
          resolve()
        })
        resolve(params)
      })
    },
    // 关闭弹窗的回调
    handleClose() {
      if (this.SplitOrderIds && this.SplitOrderIds.length && this.$route.path === '/order/details') {
        this.$router.replace({
          path: this.$route.path,
          query: {
            kkOrderId: this.SplitOrderIds
          }
        })
        this.SplitOrderIds = undefined
      }
      this.soldOutShow = false
      this.$emit('closeDialog')
    },
    // 打开编辑备注弹窗
    showEdit() {
      this.$refs.orderNoteEdit.show(this.product.kkOrderIds[0], this.orderInfo.orders.remark)
    },
    // 存在缺货商品继续生成订单并付款
    oosSplit() {
      this.loading = true
      API.orderOosSplit(this.product.kkOrderIds[0]).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        console.log(this.product)
        this.SplitOrderIds = res.data
        this.product.kkOrderIds = res.data
        this.showDialog()
      }).finally(() => {
        this.loading = false
      })
    },
    // 未发现账单地址时
    handlePayoneerError() {
      let params = {
        type: 1
      }
      this.$set(this, 'addressForm', params)
      this.isPayoneerErrorAddBillingAddress = true
      this.$refs.addressdialog.show(true)
    },
    handleResetIsPayoneerError() {
      this.isPayoneerErrorAddBillingAddress = false
    }

  }
}
</script>

<style lang="scss" scoped>
.pay-now {
  /deep/ .el-dialog__body{
    padding-top: 0;
  }
}

.PleaseSelectThePaymentMethod {
// color: #747A87;
margin-bottom: 36px;
font-size: 18px;
font-weight: bold;
}
.radioSelect {
margin-bottom: 10px;
font-size: 14px;
display: flex;
/deep/.el-radio{
  margin-right: 4px !important;
}
img{
  height: 16px;
}
}
.left{
// width: 540px;
// margin-right: 14px;
flex: 1;
border-right: 1px dashed #CDD4DD;
.orderAmount{
  // border: 1px solid #CDD4DD;
  padding: 16px 30px;
  // border-right: 1px dashed #CDD4DD;
  .subtotal_item{
    margin-bottom: 14px;
    >p:nth-of-type(1) {
      color: #747A87;
      font-size: 14px;
    }
    >p:nth-of-type(2) {
      font-size: 16px;
    }
  }
  .subtotal_all {
    margin-bottom: 14px;
    font-weight: bold;
    >p:nth-of-type(1) {
      font-size: 18px;
    }
    >p:nth-of-type(2) {
      font-size: 24px;
    }
  }
  .checkoutBtn {
    margin-bottom: 14px;
    >button{
      width: 100%;
    }
  }
  .numTip{
    text-align: center;
    font-size: 14px;
    span{
      color: #99C41C;
    }
  }
  .paymentOptions {
    p{
      text-align: center;
      color: #8B93A3;
      font-size: 14px;
      margin-bottom: 8px;
    }
    .icon_group {
      img{
        height: 14px;
      }
    }
  }
  .haveCut {
    color: #E3444E;
  }
}
}
.right{
flex: 1;
.paymentMethods{
  // border: 1px solid #CDD4DD;
  border-left: none;
  padding: 20px 0 30px 50px;
  margin-bottom: 14px;
  .payNow {
    margin-top: 40px;
  }
}
}
.shippingAddress {
  margin: 0 20px 14px;
  box-sizing: border-box;
    .text_tip{
        font-weight: bold;
        font-size: 16px;
        padding-right: 30px;
    }
    .select-another-address {
      font-size: 14px;
      color: #99c41c;
      width: 50px;
    }
  .left {
    flex: unset;
    width: 49%;
    height: 180px;
    border: unset;
    box-sizing: border-box;
    .left-address{
      height: 140px;
      width: 100%;
      border: 1px solid #CDD4DD;
      position: relative;
      box-sizing: border-box;
    }
  }
  .right {
    flex: unset;
    width: 49%;
    height: 180px;
    box-sizing: border-box;
    .right-note{
      width: 100%;
      height: 140px;
      border: 1px solid #CDD4DD;
      padding: 20px;
      box-sizing: border-box;
      >div {// 边框里面的内容设置属性
        height: 100%;
        overflow-y: auto;
        padding-right: 10px;// 右边距
      }
    }
  }
}
.deliveryMethod{
  border: 1px solid #CDD4DD;
  padding: 16px 30px;
  margin: 12px 20px;
  .channel_group{
    .channel_item{
      padding: 12px 16px;
      width: 100%;
      border: 1px solid #CDD4DD;
      margin-bottom: 10px;
    }
    .channel_item_active{
      border-color: #99C41C;
    }
  }
}
.current-address {
font-size: 14px;
color: #8b93a3;
}
.add-new-address {
font-size: 14px;
color: #99c41c;
line-height: 30px;
padding-bottom: 14px;
}
.address-item {
width: 377px;
border: 0.5px solid #cdd4dd;
border-radius: 6px;
padding: 15px 15px 26px 15px;
margin-bottom: 17px;
overflow: hidden;
span {
  position: absolute;
  right: 10px;
  bottom: 4px;
  color: #99c41c;
}
}
.address-item-activated {
border: 0.5px solid #99c41c;
.activated-icon {
  display: block;
  position: absolute;
  right: -35px;
  top: -35px;
  width: 60px;
  height: 60px;
  border-radius: 100px;
  background: #99c41c;
  color: white;
  i {
    position: absolute;
    bottom: 3px;
    left: 8px;
  }
}
}
.activated-icon {
display: none;
}
.productParts {
  border: 1px solid #CDD4DD;
  margin: 12px 20px;
  padding: 16px 30px;
}

.sold-out-dialog {
  /deep/ .el-dialog__body{
    padding: 0;
    // padding: 10px 20px 10px 50px;
    max-height: 500px;
    overflow: auto;
  }
  .sold-out{
    margin-bottom: 10px;
    .sku {
      width: 340px;
    }
    .status {
      width: 160px;
    }
  }
}
</style>

<style lang="scss">
.message_Zindex{
z-index: 10000 !important;
}
</style>
